import { WorkflowNodeOutput } from '../types'
import { hasSchemaGeomField } from '../../builder/state/builderSliceUtils'

export function hasGeomField(outputs: WorkflowNodeOutput[]) {
  for (const { schema } of outputs) {
    if (hasSchemaGeomField(schema)) {
      return true
    }
  }
  return false
}

export function stringToOptions(value: unknown) {
  const parts = (value as string).split(',')

  return parts
    .map((item, index) => {
      if (index % 2 === 0) {
        return `${item}_${parts[index + 1]}`
      }

      return null
    })
    .filter(Boolean)
}
